export const categoryModel = {
    name: null,
    slug: null,
    description: null,
    parent_category: null
}
